// extracted by mini-css-extract-plugin
export default {"video":"VideoMobile_video__I4G8h","videoInvisible":"VideoMobile_videoInvisible__Jz2ak","videoVisible":"VideoMobile_videoVisible__pF3rZ"};